export default __webpack_public_path__ + "media/zurb/img/events/wired/sacred-heart/sacred-heart-img3-96341d9d294ec6375e56d56463018450.jpg";